import { render, staticRenderFns } from "./ReadOnly.vue?vue&type=template&id=0d016de0&"
import script from "./ReadOnly.vue?vue&type=script&lang=js&"
export * from "./ReadOnly.vue?vue&type=script&lang=js&"
import style0 from "./ReadOnly.vue?vue&type=style&index=0&id=0d016de0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports